/* ============================================================
   thesis® global behaviour — loaded on every page (layout/theme.liquid)
   1. PDP desktop gallery: native-scroll engine (works with window OR the theme's page container)
   2. Checkout buttons (drawer + cart page) go straight to checkout
============================================================ */
(function () {
  if (window.__thesisGlobal) return;
  window.__thesisGlobal = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* The element that actually scrolls the page: on desktop this theme scrolls a page
     container instead of the window. Returns null when the window scrolls. */
  function findScroller(el) {
    var node = el ? el.parentElement : null;
    while (node && node !== document.body && node !== document.documentElement) {
      var style = window.getComputedStyle(node);
      if (/(auto|scroll|overlay)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
      node = node.parentElement;
    }
    return null;
  }

  function scrollTopOf(scroller) {
    if (scroller) return scroller.scrollTop;
    var s = document.scrollingElement || document.documentElement;
    return Math.max(0, window.pageYOffset || 0, s.scrollTop || 0);
  }

  function viewportTopOf(scroller) {
    return scroller ? scroller.getBoundingClientRect().top : 0;
  }

  /* ---------- 1. PDP desktop gallery ----------
     Original order: media column stays put while its images move up; after the last image
     the gap under the header fills; then the page continues. The page always scrolls natively. */
  var pdp = null;
  var ticking = false;

  function resetPdp(state) {
    if (!state) return;
    ['position', 'top', 'marginBottom', 'overflow', 'alignSelf', 'transform', 'willChange'].forEach(function (p) { state.media.style[p] = ''; });
    state.gallery.style.transform = '';
    state.gallery.style.willChange = '';
    if (state.info) state.info.style.top = '';
  }

  function setupPdp() {
    if (pdp) resetPdp(pdp);
    pdp = null;
    var section = document.querySelector('.thesis-pdp--assembly_grid');
    if (!section || window.innerWidth <= 990) return;
    var media = section.querySelector('.thesis-pdp__media');
    var gallery = section.querySelector('[data-thesis-gallery]');
    if (!media || !gallery) return;

    var scroller = findScroller(section);
    var info = section.querySelector('.thesis-pdp__sticky');
    media.scrollTop = 0;
    var y = scrollTopOf(scroller);
    var base = viewportTopOf(scroller);
    var mediaTop = media.getBoundingClientRect().top - base + y;
    var infoTop = info ? info.getBoundingClientRect().top - base + y : 0;
    var travel = Math.max(0, gallery.scrollHeight - media.clientHeight);

    media.style.overflow = 'hidden';
    media.style.position = 'sticky';
    media.style.alignSelf = 'start';
    media.style.top = mediaTop + 'px';
    media.style.marginBottom = travel + 'px';
    gallery.style.willChange = 'transform';
    if (info && infoTop > 0 && infoTop < window.innerHeight * 0.6) info.style.top = infoTop + 'px';

    pdp = {
      section: section, media: media, gallery: gallery, info: info, scroller: scroller,
      travel: travel, top: mediaTop, mode: 'sticky', checked: false,
      progress: section.querySelector('.thesis-pdp__progress'),
      fill: section.querySelector('[data-thesis-progress]')
    };
    updatePdp();
  }

  function updatePdp() {
    ticking = false;
    if (!pdp) return;
    if (!pdp.section.isConnected) { setupPdp(); return; }
    var y = scrollTopOf(pdp.scroller);
    var offset = Math.min(Math.max(y, 0), pdp.travel);

    if (pdp.mode === 'sticky' && !pdp.checked && offset > 20) {
      pdp.checked = true;
      var current = pdp.media.getBoundingClientRect().top - viewportTopOf(pdp.scroller);
      if (Math.abs(current - pdp.top) > 4) {
        pdp.mode = 'follow';
        pdp.media.style.position = 'relative';
        pdp.media.style.top = '0px';
        pdp.media.style.willChange = 'transform';
      }
    }
    if (pdp.mode === 'follow') pdp.media.style.transform = 'translate3d(0,' + offset + 'px,0)';

    pdp.gallery.style.transform = 'translate3d(0,' + (-offset) + 'px,0)';
    var progress = pdp.travel > 0 ? offset / pdp.travel : 1;
    if (pdp.fill) { pdp.fill.style.height = (progress * 100) + '%'; pdp.fill.style.width = '1px'; }
    if (pdp.progress) pdp.progress.classList.toggle('is-visible', progress < 0.995);
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(updatePdp); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupPdp, 150);
  });

  /* the section's old wheel hand-off must not run: the page scrolls natively */
  document.addEventListener('wheel', function (event) {
    if (!pdp || window.innerWidth <= 990) return;
    if (event.target && event.target.closest && event.target.closest('.thesis-pdp--assembly_grid .thesis-pdp__media')) {
      event.stopPropagation();
    }
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-sibling-product-url]')) setTimeout(setupPdp, 700);
  });

  function boot() { requestAnimationFrame(setupPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', setupPdp);
  document.addEventListener('shopify:section:load', function () { setTimeout(setupPdp, 100); });

  /* ---------- 2. Checkout ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.tc__checkout, .tcart__checkout, [data-thesis-checkout]');
    if (!button) return;
    event.preventDefault();
    button.classList.add('is-loading');
    var form = button.closest('form');
    var note = form ? form.querySelector('textarea[name="note"]') : null;
    var go = function () { window.location.href = root + 'checkout'; };
    if (note) {
      fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).then(go, go);
    } else {
      go();
    }
  });
})();
